import { RootState } from "@/redux/store";

export const externalSuppliersSelector = (state: RootState) => state.externalSupplier.suppliers;
export const externalSuppliersPageSelector = (state: RootState) => state.externalSupplier.page;
export const externalSuppliersFormOptionsSelector = (state: RootState) => state.externalSupplier.options;
